import receituarioServices from "@/api/receituario/receituarioServices";

export default {
  save({ commit }, data) {
    return receituarioServices
      .save(data)
      .then((result) => result)
      .catch((error) => error);
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) =>
      receituarioServices
        .getById(id)
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => reject(err))
    );
  },
  getPatientById({ commit }, id) {
    return new Promise((resolve, reject) =>
      receituarioServices
        .getPatientById(id)
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => reject(err))
    );
  },
  getPatientAndSpecialtyById({ commit }, id) {
    return new Promise((resolve, reject) =>
      receituarioServices
        .getPatientAndSpecialtyById(id)
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => reject(err))
    );
  },
};
